import { render } from "./AdminLongTimeNoSeeComp.vue?vue&type=template&id=0fa4a980&scoped=true"
import script from "./AdminLongTimeNoSeeComp.vue?vue&type=script&lang=js"
export * from "./AdminLongTimeNoSeeComp.vue?vue&type=script&lang=js"

import "./AdminLongTimeNoSeeComp.vue?vue&type=style&index=0&id=0fa4a980&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa4a980"]])

export default __exports__